const discountIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16">
      <g fill="none" fill-rule="evenodd">
        <path stroke="#C9CCCD" stroke-linecap="round" stroke-linejoin="round" d="M23.5,11 C21.843,11 20.5,9.657 20.5,8 C20.5,6.344 21.843,5 23.5,5 L23.5,0.5 L0.5,0.5 L0.5,5 C2.156,5 3.5,6.344 3.5,8 C3.5,9.657 2.156,11 0.5,11 L0.5,15.5 L23.5,15.5 L23.5,11 Z"/>
        <polygon fill="#C9CCCD" fill-rule="nonzero" points="19 2 18 2 18 3 19 3"/>
        <polygon fill="#C9CCCD" fill-rule="nonzero" points="19 4 18 4 18 5 19 5"/>
        <polygon fill="#C9CCCD" fill-rule="nonzero" points="19 6 18 6 18 7 19 7"/>
        <polygon fill="#C9CCCD" fill-rule="nonzero" points="19 9 18 9 18 10 19 10"/>
        <polygon fill="#C9CCCD" fill-rule="nonzero" points="19 11 18 11 18 12 19 12"/>
        <polygon fill="#C9CCCD" fill-rule="nonzero" points="19 13 18 13 18 14 19 14"/>
        <path stroke="#C9CCCD" stroke-linecap="round" stroke-linejoin="round" d="M7,12 L15,4"/>
        <circle cx="8" cy="5" r="1.5" stroke="#C9CCCD" stroke-linecap="round" stroke-linejoin="round"/>
        <circle cx="14" cy="11" r="1.5" stroke="#C9CCCD" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
    </svg>
    
`;

export default discountIcon;
